import { jsonStringify } from "./json.js";
function groupBy(arr, funcOrString) {
    if (typeof funcOrString === "function") {
        const alias = arr;
        return alias.reduce((result, obj) => {
            const value = funcOrString(obj);
            return {
                ...result,
                [value]: result[value] ? [...result[value], obj] : [obj],
            };
        }, {});
    }
    if (typeof funcOrString === "string") {
        const alias = arr;
        return alias.reduce((result, obj) => {
            const value = obj[funcOrString];
            return {
                ...result,
                [value]: result[value] ? [...result[value], obj] : [obj],
            };
        }, {});
    }
    throw new Error("groupBy must be called with a function or a string");
}
//sorted n'est pas utilisé mais maintenu pour compatibilité avec underscore
const uniq = (arr, _sorted, fun) => {
    if (fun) {
        const lastAdded = [];
        const uniqMap = arr.reduce((result, obj) => {
            const value = fun(obj);
            if (value === undefined) {
                lastAdded.push(obj);
                return result;
            }
            return {
                ...result,
                ...(result[value] ? {} : { [value]: obj }),
            };
        }, {});
        return [...Object.values(uniqMap), ...lastAdded];
    }
    const s = new Set(arr);
    return Array.from(s);
};
//first renvoie undefined si l'array est vide
const first = (arr) => {
    if (arr.length === 0) {
        return;
    }
    return arr[0];
};
function isNonEmpty(arr) {
    return arr.length > 0;
}
function isEmpty(arr) {
    return arr.length === 0;
}
//head renvoie toujours un élément
//doit être utilisé avec isNonEmpty avant
const head = (arr) => {
    return arr[0];
};
const last = (arr) => {
    if (arr.length === 0) {
        return;
    }
    return arr[arr.length - 1];
};
const lastNonEmpty = (arr) => {
    return arr[arr.length - 1];
};
const tail = (arr) => {
    if (arr.length < 2) {
        return [];
    }
    return arr.slice(1);
};
const getAt = (arr, index) => {
    return arr[index];
};
const range = (num1, num2, step) => {
    if (!num2) {
        //juste le stop
        const arr = [];
        for (let i = 0; i < num1; i++) {
            arr.push(i);
        }
        return arr;
    }
    const arr = [];
    if (num1 < num2) {
        if (step && step < 0) {
            throw new Error("step must be positive");
        }
        for (let i = num1; i < num2; step ? (i = i + step) : (i = i + 1)) {
            arr.push(i);
        }
        return arr;
    }
    if (num1 > num2) {
        if (step && step > 0) {
            throw new Error("step must be negative");
        }
        for (let i = num1; i > num2; step ? (i = i + step) : (i = i - 1)) {
            arr.push(i);
        }
        return arr;
    }
    if (num1 === num2) {
        return [];
    }
    throw new Error("should not get here");
};
const sortBy = (arr, compareFuncOrKey) => {
    if (Array.isArray(compareFuncOrKey)) {
        return arr.sort((a, b) => {
            for (let i = 0; i < compareFuncOrKey.length; i++) {
                const key = compareFuncOrKey[i];
                if (a[key] < b[key]) {
                    return -1;
                }
                if (a[key] > b[key]) {
                    return 1;
                }
            }
            return 0;
        });
    }
    if (typeof compareFuncOrKey === "string") {
        return arr.sort((a, b) => {
            if (a[compareFuncOrKey] < b[compareFuncOrKey]) {
                return -1;
            }
            if (a[compareFuncOrKey] > b[compareFuncOrKey]) {
                return 1;
            }
            return 0;
        });
    }
    if (typeof compareFuncOrKey === "function") {
        return arr.sort((a, b) => {
            const resulta = compareFuncOrKey(a);
            const resultb = compareFuncOrKey(b);
            if (resulta < resultb) {
                return -1;
            }
            if (resulta > resultb) {
                return 1;
            }
            return 0;
        });
    }
    throw new Error("compareFuncOrKey must be a string or a function");
};
const invert = (obj) => Object.entries(obj).reduce((result, [key, value]) => ({ ...result, [value]: key }), {});
const compact = (arr) => arr.filter((t) => !!t);
const take = (arr, n) => arr.slice(0, n);
const mapObject = (obj, func) => {
    return Object.entries(obj).reduce((result, [key, value]) => {
        return { ...result, [key]: func(value) };
    }, {});
};
const difference = (arr1, arr2) => {
    const result = [];
    function isInArr2(val) {
        return arr2.some((t) => t === val);
    }
    for (let i = 0; i < arr1.length; i++) {
        const element = arr1[i];
        if (!isInArr2(element)) {
            result.push(element);
        }
    }
    return result;
};
const intersection = (arr1, arr2) => {
    const result = [];
    function isInArr2(val) {
        return arr2.some((t) => t === val);
    }
    for (const element of arr1) {
        if (isInArr2(element)) {
            result.push(element);
        }
    }
    return result;
};
//TODO typage pourri
const without = (arr, ...values) => {
    // @ts-ignore
    return arr.filter((t) => !values.includes(t));
};
const isFunction = (func) => {
    return typeof func === "function";
};
const isString = (str) => {
    return typeof str === "string";
};
const isDate = (date) => {
    return date instanceof Date;
};
const compareNaNAndNull = (a, b) => {
    if (Number.isNaN(a) && Number.isNaN(b)) {
        return true;
    }
    if (a === null && b === null) {
        return true;
    }
    if (Number.isNaN(a) && b === null) {
        return false;
    }
    if (a === null && Number.isNaN(b)) {
        return false;
    }
    return JSON.stringify(a) === JSON.stringify(b);
};
const compareMaps = (a, b) => {
    if (a.size !== b.size) {
        return false;
    }
    for (const [key, value] of a.entries()) {
        if (!b.has(key) || !isEqual(value, b.get(key))) {
            return false;
        }
    }
    return true;
};
const isEqual = function isEqual(a, b) {
    if (Number.isNaN(a) || Number.isNaN(b)) {
        return compareNaNAndNull(a, b);
    }
    if (a === null || b === null) {
        return compareNaNAndNull(a, b);
    }
    if (a instanceof Map && b instanceof Map) {
        return compareMaps(a, b);
    }
    return JSON.stringify(a) === JSON.stringify(b);
};
const keys = (obj) => {
    return Object.keys(obj);
};
/**
 * does the reverse TS wise of Array.prototype.includes
 *
 * @remarks
 * thank you @ddprrt
 *
 *
 */
const includes = (coll, el) => coll.includes(el);
const cleanUndefAndNullKeysInObject = (obj) => {
    return Object.keys(obj).reduce((result, key) => {
        if (obj[key] != null) {
            return { ...result, [key]: obj[key] };
        }
        return result;
    }, {});
};
function assertField(obj, field) {
    if (!obj[field]) {
        throw new Error(`field ${field} is not defined`);
    }
}
function hasField(obj, field) {
    return obj[field] !== undefined;
}
function assertProp(Obj, prop) {
    return typeof Obj === "object" && Obj !== null && prop in Obj;
}
const windows = (arr, n) => {
    const result = [];
    for (let i = 0; i < arr.length - n + 1; i++) {
        result.push(arr.slice(i, i + n));
    }
    return result;
};
const pick = (obj, keys) => {
    return keys.reduce((result, key) => {
        return { ...result, [key]: obj[key] };
    }, {});
};
const omit = (obj, keys) => {
    const allKeys = Object.keys(obj);
    return allKeys.reduce((result, key) => {
        if (Array.isArray(keys) && !includes(keys, key)) {
            return { ...result, [key]: obj[key] };
        }
        if (typeof keys === "string" && key !== keys) {
            return { ...result, [key]: obj[key] };
        }
        return result;
    }, {});
};
const rest = (arr, n) => {
    if (n === undefined) {
        return arr.slice(1);
    }
    return arr.slice(n);
};
const initial = (arr, n) => {
    if (n === undefined) {
        return arr.slice(0, -1);
    }
    return arr.slice(0, -n);
};
const nth = (arr, n) => {
    if (n >= 0) {
        return arr[n];
    }
    else {
        return arr[arr.length + n];
    }
};
function groupByKey(arr, key) {
    return arr.reduce((accumulator, val) => {
        const groupedKey = val[key];
        if (!accumulator[groupedKey]) {
            accumulator[groupedKey] = [];
        }
        accumulator[groupedKey].push(val);
        return accumulator;
    }, {});
}
function groupByFunc(arr, mapper) {
    return arr.reduce((accumulator, val) => {
        const groupedKey = mapper(val);
        if (!accumulator[groupedKey]) {
            accumulator[groupedKey] = [];
        }
        accumulator[groupedKey].push(val);
        return accumulator;
    }, {});
}
function getSafeMapValue(map, key) {
    const keys = Object.keys(map);
    const stringifiedKey = key.toString();
    if (keys.includes(stringifiedKey)) {
        return map[key];
    }
    return undefined;
}
function _parseInt(value) {
    const parsed = parseInt(value);
    if (Number.isNaN(parsed)) {
        return null;
    }
    return parsed;
}
function convertNullableKeysToOptionnal(obj) {
    return Object.keys(obj).reduce((acc, key) => {
        if (obj[key] === null) {
            return acc;
        }
        return { ...acc, [key]: obj[key] };
    }, {});
}
function convertOptionnalKeysToNullable(obj, keys) {
    return keys.reduce((acc, key) => {
        if (obj[key] === undefined) {
            return { ...acc, [key]: null };
        }
        return { ...acc, [key]: obj[key] };
    }, obj);
}
function jsonParse(str, reviver) {
    try {
        return JSON.parse(str, reviver);
    }
    catch (e) {
        return undefined;
    }
}
export default {
    groupBy,
    groupByKey,
    groupByFunc,
    uniq,
    sortBy,
    first,
    last,
    tail,
    range,
    invert,
    compact,
    take,
    mapObject,
    difference,
    intersection,
    without,
    isFunction,
    isString,
    isDate,
    isEqual,
    isEmpty,
    getAt,
    includes,
    keys,
    cleanUndefAndNullKeysInObject,
    assertField,
    hasField,
    assertProp,
    windows,
    pick,
    omit,
    rest,
    initial,
    nth,
    isNonEmpty,
    head,
    lastNonEmpty,
    getSafeMapValue,
    parseInt: _parseInt,
    convertNullableKeysToOptionnal,
    convertOptionnalKeysToNullable,
    jsonParse,
    jsonStringify,
};
//# sourceMappingURL=index.js.map